import { InteractiveContainer } from "@jugl-web/ui-kit";
import { cx, useTranslations } from "@jugl-web/utils";
import React from "react";
import { aiGradientBackgroundClassName } from "@jugl-web/domain-resources/ai-assistant/consts";
import { ReactComponent as AttentionIcon } from "./assets/attention.svg";
import { ReactComponent as RetryIcon } from "./assets/retry.svg";

export const AIErrorState: React.FC<{
  orientation: "row" | "column";
  onRetry?: () => void;
}> = ({ orientation, onRetry }) => {
  const { t } = useTranslations();

  return (
    <div
      className={cx(
        "flex items-center justify-center gap-6 p-6",
        orientation === "column" && "flex-col",
        onRetry && "justify-between"
      )}
    >
      <span
        className={cx(
          "items-center font-secondary text-sm leading-[21px] text-dark",
          orientation === "column" &&
            "flex max-w-[300px] flex-col items-center gap-2 text-center"
        )}
      >
        <AttentionIcon className="shrink-0 align-middle" />{" "}
        <span>
          {t({
            id: "ai-assistant-accordion-component.glitch-occured-try-again",
            defaultMessage:
              "Oops! A little glitch occurred while preparing your request",
          })}{" "}
          🤖
        </span>
      </span>
      {onRetry && (
        <InteractiveContainer
          className={cx(
            "flex h-8 items-center justify-center gap-1.5 rounded-lg px-[14px]",
            aiGradientBackgroundClassName
          )}
          onClick={onRetry}
        >
          <RetryIcon />
          <span className="font-secondary text-[15px] leading-[21px] text-white">
            {t({ id: "common.retry", defaultMessage: "Retry" })}
          </span>
        </InteractiveContainer>
      )}
    </div>
  );
};
